import * as React from "react";
import { NavigationList } from "./navigationList";
import { styled } from "utils";
import { NavigationBurger } from "./navigationBurger";
import { Box, Logo, Flex } from "../../atoms";
import { Drawer, DrawerContent, DrawerToggleButton } from "../../molecules";
import { IconTwitter, IconFacebook } from "../../icons";
import { useStickyHeader } from "hooks";

const StyledHeader = styled(Box, {
  position: "sticky",
  width: "100%",
  top: 0,
  zIndex: 100,
  transition: "transform 350ms",
  backgroundColor: "$white",
});

const StyledNav = styled(Flex, {
  display: "flex",
  height: 88,
  padding: "$4",
  alignItems: "center",
  boxShadow: "$cards",
  marginBottom: "$5",
  "@bp2": { marginBottom: "$7" },
  "@bp3": { marginBottom: "$9" },
  variants: {
    variation: {
      home: { marginBottom: 0 },
    },
  },
  defaultVariants: { variation: "default" },
});

const DesktopNav = styled(Box, {
  marginLeft: "auto",
  display: "none",
  "@bp2": { display: "flex" },
});

const StyledBurger = styled(NavigationBurger, {
  "@bp2": { display: "none" },
});

const SocialMediaIcon = styled("a", {
  display: "flex",
  cursor: "pointer",
  "&:hover svg": {
    fill: "$green2",
    "& path": { stroke: "$white" },
  },
});

type Props = React.HTMLAttributes<HTMLElement> & {
  variation?: "home" | undefined;
};

const SocialMedias = () => {
  return (
    <Flex css={{ gap: "$3", alignItems: "center" }}>
      <SocialMediaIcon
        href="https://twitter.com/campos_uy"
        target="_blank"
        rel="noreferrer"
        aria-label="Twitter"
      >
        <IconTwitter />
      </SocialMediaIcon>
      <SocialMediaIcon
        href="https://www.facebook.com/Campos-UY-109113244949708"
        target="_blank"
        rel="noreferrer"
        aria-label="Facebook"
      >
        <IconFacebook />
      </SocialMediaIcon>
    </Flex>
  );
};

const Navigation: React.FC<Props> = ({ variation }) => {
  const isHeaderVisible = useStickyHeader();
  const transform = isHeaderVisible ? "translateY(0%)" : "translateY(-200%)";
  const transformBurger = isHeaderVisible
    ? "translateY(0%)"
    : "translateY(-200%)";

  return (
    <StyledHeader as="header" style={{ transform }}>
      <StyledNav as="nav" variation={variation}>
        <Logo />

        <Drawer>
          <DrawerToggleButton>
            <StyledBurger style={{ transform: transformBurger }} />
          </DrawerToggleButton>
          <DrawerContent aria-label="Navigation drawer">
            <NavigationList direction="column" css={{ marginBottom: "$5" }} />
            <SocialMedias />
          </DrawerContent>
        </Drawer>

        <DesktopNav>
          <NavigationList />
          <SocialMedias />
        </DesktopNav>
      </StyledNav>
    </StyledHeader>
  );
};

export { Navigation };
